import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
  useMultiStyleConfig,
} from '@chakra-ui/react'
import { MultiStyleType } from '@chakra-ui/styled-system'
import { textStyleKeys } from '~/themes/textStyles'
import { textStyles } from '~/themes/textStyles/defaultTextStyles'
import { getName } from '~/utils/objectUtils'

export const enum IncomingCallModalVariants {
  SingleRow = 'singleRow',
  DoubleRow = 'doubleRow',
}

const incomingCallModalParts = [
  'modal',
  'headerBlock',
  'headerText',
  'callerName',
  'callerNumber',
  'buttonRow',
] as const

const helpers = createMultiStyleConfigHelpers(incomingCallModalParts)

export const IncomingCallModalStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    modal: {
      flexDirection: 'column',
      padding: '4rem',
    },
    headerBlock: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      paddingX: '1.25rem',
    },
    headerText: {
      ...textStyles[textStyleKeys.Body1],
    },
    callerName: {
      ...textStyles[textStyleKeys.H3],
      textAlign: 'center',
    },
    callerNumber: {
      ...textStyles[textStyleKeys.Body1],
    },
    buttonRow: {
      justifyContent: 'center',
      gap: '2rem',
    },
  },
  variants: {
    [IncomingCallModalVariants.SingleRow]: {
      modal: {
        gap: '2.5rem',
      },
    },
    [IncomingCallModalVariants.DoubleRow]: {
      modal: {
        gap: '2rem',
      },
    },
  },
})

const incomingCallModalName = getName({ IncomingCallModalStyle })

export const useIncomingCallModalStyles = (props?: StyleThemingProps) => {
  return useMultiStyleConfig(incomingCallModalName, props) as MultiStyleType<
    typeof incomingCallModalParts
  >
}
